var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplayPre)?_c('pre',{class:_vm.$style.basePre},[_vm._v("  "),_vm._t("default"),_vm._v("\n")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }